var Bookmark, Buffer, DbHelper, Document, FileSaver, Footer, HEALTH_ADVISOR_WORKSPACE_ID, HeadingLevel, ITALICS_REGEXP, ImageRun, NumberFormat, Packer, PageNumber, Paragraph, SectionType, TabStopPosition, TabStopType, TextRun, W, acoemLogoBase64, alt, amaFormat, base64ToBlob, chapterTitle, convertFromDraftJSToWordDoc, createChaptersListWithNumericKeys, createWordExport, dataUrlRegex, errorHandler, errorLoadingImageBase64, fetchDocs, footerParagraph, gatherer, get, getCertaintyOfEvidenceCircles, getExportStyles, getMDGRecommendationParagraph, getRecommendationDirectionAndStrength, getRecommendationParagraph, getReferencesSet, getSchema, insertExtension, isDocx, isEvolent, isHealthAdvisor, isMdgTablesSwitchOn, loadImage, loadImageWithCanvas, loadImageWithXHR, mapImmutableToJsWithPromise, mapReferenceCitationPartsToTextRuns, mediator, numberSort, pageNumberingFormat, paragraphTitle, paragraphWithEditorContent, prepareState, processExtensions, recommendationAndQuestionExists, reduceImmutableWithPromise, referencesTextRun, removeHTMLNode, renderEditorValue, replaceReference, sectionLinksExtension, sequence, serializeNode, simpleTitle, vancouverFormat, _ref, _ref1, _ref2, _ref3,
  __slice = [].slice;

Bookmark = docx.Bookmark, Document = docx.Document, Footer = docx.Footer, HeadingLevel = docx.HeadingLevel, ImageRun = docx.ImageRun, NumberFormat = docx.NumberFormat, Packer = docx.Packer, PageNumber = docx.PageNumber, Paragraph = docx.Paragraph, SectionType = docx.SectionType, TabStopPosition = docx.TabStopPosition, TabStopType = docx.TabStopType, TextRun = docx.TextRun;

FileSaver = require('lib/file_saver');

alt = require('alt');

W = require('when');

DbHelper = require('base/lib/db_helper');

sequence = require('when/sequence');

insertExtension = require('components/document_sections/v2/editor_extensions/insert/insert');

sectionLinksExtension = require('components/document_sections/v2/editor_extensions/section_links/section_links');

mediator = require('mediator');

getExportStyles = require('lib/word_export/styles');

errorHandler = require('lib/app_utils').errorHandler;

get = require('lodash').get;

isDocx = require('lib/docx_export_helpers').isDocx;

HEALTH_ADVISOR_WORKSPACE_ID = require('lib/mda_helper').HEALTH_ADVISOR_WORKSPACE_ID;

Buffer = buffer.Buffer;

getSchema = Epiditor.getSchema, prepareState = Epiditor.prepareState, processExtensions = Epiditor.processExtensions;

_ref = require('lib/references_utils'), vancouverFormat = _ref.vancouverFormat, amaFormat = _ref.amaFormat;

_ref1 = require('lib/services/covid_exporter/utils'), getRecommendationDirectionAndStrength = _ref1.getRecommendationDirectionAndStrength, getCertaintyOfEvidenceCircles = _ref1.getCertaintyOfEvidenceCircles, renderEditorValue = _ref1.renderEditorValue;

serializeNode = require('lib/word_export/serializer').serializeNode;

_ref2 = require('lib/immutable_utils'), mapImmutableToJsWithPromise = _ref2.mapImmutableToJsWithPromise, reduceImmutableWithPromise = _ref2.reduceImmutableWithPromise;

_ref3 = require('base/lib/utils'), removeHTMLNode = _ref3.removeHTMLNode, numberSort = _ref3.numberSort;

mediator = require('mediator');

dataUrlRegex = /^data:image\/[A-Za-z]*;base64,/;

errorLoadingImageBase64 = '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';

acoemLogoBase64 = 'data:image/png;base64,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';

createChaptersListWithNumericKeys = function(currentList, chapterIds, initialKey) {
  var Store, chapters;
  if (initialKey == null) {
    initialKey = Immutable.List();
  }
  Store = alt.stores.DocumentSectionsV2Store;
  chapters = Store.getChapters();
  return chapterIds.reduce(function(acc, chapterId, key) {
    var chapter, chapterKey, subchaptersIds;
    chapterKey = initialKey.push(key + 1);
    chapter = chapters.get(chapterId);
    if (!chapter) {
      return acc;
    }
    acc = acc.push(chapter.set('chapterKeys', chapterKey));
    subchaptersIds = chapter.get('subchapters');
    if (!subchaptersIds.isEmpty()) {
      acc = createChaptersListWithNumericKeys(acc, subchaptersIds, chapterKey);
    }
    return acc;
  }, currentList);
};

fetchDocs = function(projectId, docsIds) {
  if (projectId == null) {
    projectId = mediator.project.id;
  }
  return mediator.services.storePersistenceAdapter.fetch(projectId, docsIds).then(function(res) {
    return _.pluck(res.rows, 'doc');
  });
};

loadImageWithCanvas = function(src, useCORS) {
  if (useCORS == null) {
    useCORS = false;
  }
  return new Promise(function(resolve, reject) {
    var img;
    img = new Image();
    if (useCORS) {
      img.crossOrigin = 'anonymous';
    }
    img.src = src;
    img.onload = function() {
      var canvas, ctx, dataURL, err;
      canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      try {
        ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        dataURL = canvas.toDataURL('image/png');
        return resolve(dataURL);
      } catch (_error) {
        err = _error;
        return reject(err);
      } finally {
        removeHTMLNode(canvas);
      }
    };
    return img.onerror = reject;
  });
};

loadImageWithXHR = function(src) {
  return new Promise(function(resolve, reject) {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader;
      reader = new FileReader();
      reader.onloadend = function() {
        return resolve(reader.result);
      };
      return reader.readAsDataURL(xhr.response);
    };
    xhr.onerror = reject;
    xhr.open('GET', src);
    xhr.responseType = 'blob';
    return xhr.send();
  });
};

loadImage = function(src) {
  var res;
  res = {};
  if (!dataUrlRegex.test(src)) {
    return loadImageWithCanvas(src)["catch"](function() {
      return loadImageWithCanvas(src, true);
    })["catch"](function() {
      return loadImageWithXHR(src);
    }).then(function(result) {
      res["" + src] = result.replace(dataUrlRegex, '');
      return res;
    })["catch"](function() {
      res["" + src] = errorLoadingImageBase64;
      return res;
    });
  } else {
    res["" + src] = src.replace(dataUrlRegex, '');
    return W.resolve(res);
  }
};

isMdgTablesSwitchOn = function() {
  return mediator.services.switches.isOn('mdgTables');
};

isHealthAdvisor = function() {
  return mediator.activeWorkspace === HEALTH_ADVISOR_WORKSPACE_ID;
};

isEvolent = function() {
  return mediator.services.switches.isServerSwitchOn('evolentFeatures');
};

pageNumberingFormat = function() {
  if (isEvolent()) {
    return [
      new TextRun({
        text: "Page ",
        size: 20
      }), new TextRun({
        children: [PageNumber.CURRENT],
        size: 20
      }), new TextRun({
        text: " of ",
        size: 20
      }), new TextRun({
        children: [PageNumber.TOTAL_PAGES],
        size: 20
      })
    ];
  } else {
    return [
      new TextRun({
        children: ["\t", PageNumber.CURRENT]
      })
    ];
  }
};

footerParagraph = function() {
  var footerChildren;
  footerChildren = [
    new Paragraph({
      size: 20,
      style: 'footer',
      children: [new TextRun({
          text: isMdgTablesSwitchOn() || isHealthAdvisor() ? $.t('mdg_tables:export_copyright', {
            year: new Date().getFullYear()
          }) : '',
          size: 20,
          color: "#dddddd"
        })].concat(__slice.call(pageNumberingFormat())),
      tabStops: [
        {
          type: isEvolent() ? TabStopType.LEFT : TabStopType.RIGHT,
          position: TabStopPosition.MAX
        }
      ]
    })
  ];
  if (isEvolent()) {
    footerChildren.push(new Paragraph({
      style: 'footer',
      children: [
        new TextRun({
          text: mediator.project.get('name'),
          size: 20
        })
      ]
    }));
  }
  return new Footer({
    size: 20,
    children: footerChildren
  });
};

referencesTextRun = function(refs) {
  return !_.isEmpty(refs) && new TextRun({
    text: " (" + (refs.sort(numberSort).join(',')) + ")",
    superScript: true
  });
};

chapterTitle = function(chapter, referencesOrder) {
  var refs;
  if (referencesOrder == null) {
    referencesOrder = Immutable.List();
  }
  if (_.isEmpty(chapter.get('title'))) {
    return null;
  }
  refs = (chapter.get('refIds', Immutable.List()).map(function(refId) {
    return referencesOrder.indexOf(refId) + 1;
  })).toJS() || [];
  return new Paragraph({
    children: [
      new Bookmark({
        id: chapter.get('_id'),
        children: _.compact([
          new TextRun({
            text: chapter.get('title')
          }), referencesTextRun(refs)
        ])
      })
    ],
    heading: HeadingLevel.HEADING_2
  });
};

simpleTitle = function(text, id) {
  var paragraphStyle;
  paragraphStyle = getExportStyles().paragraphStyle;
  if (_.isEmpty(text)) {
    return null;
  }
  return new Paragraph(_.extend({
    children: [
      new Bookmark({
        id: id,
        children: [
          new TextRun({
            text: text
          })
        ]
      })
    ],
    heading: HeadingLevel.HEADING_3
  }, _.omit(paragraphStyle, 'alignment', 'spacing')));
};

paragraphTitle = function(section, referencesOrder) {
  var id, paragraphStyle, refs, text;
  if (referencesOrder == null) {
    referencesOrder = Immutable.List();
  }
  paragraphStyle = getExportStyles().paragraphStyle;
  text = section.get('title');
  id = section.get('_id');
  if (_.isEmpty(text)) {
    return null;
  }
  refs = (section.get('refIds', Immutable.List()).map(function(refId) {
    return referencesOrder.indexOf(refId) + 1;
  })).toJS() || [];
  return new Paragraph(_.extend({
    children: [
      new Bookmark({
        id: id,
        children: _.compact([
          new TextRun({
            text: text
          }), referencesTextRun(refs)
        ])
      })
    ],
    heading: HeadingLevel.HEADING_3
  }, _.omit(paragraphStyle, 'alignment', 'spacing')));
};

paragraphWithEditorContent = function(section, wordDocument, referencesOrder) {
  return _.compact([paragraphTitle(Immutable.fromJS(section), referencesOrder) || null, wordDocument]);
};

gatherer = function(nodeType, itemMapper) {
  if (itemMapper == null) {
    itemMapper = _.identity;
  }
  return function(node) {
    return _.chain(node != null ? node.content : void 0).map(function(item) {
      if (item.type === nodeType) {
        return itemMapper(item);
      } else if ((item != null ? item.content : void 0) && !_.isEmpty(item.content)) {
        return gatherer(nodeType, itemMapper)(item);
      }
    }).compact().flatten().value();
  };
};

getReferencesSet = function(references) {
  var refIds, refs;
  refs = Immutable.fromJS(_.flatten(references));
  refIds = refs.reduce(function(acc, references) {
    return acc.union(references.getIn(['attrs', 'refIds'], Immutable.List()));
  }, Immutable.OrderedSet());
  references = refs.reduce(function(acc, currentReferences) {
    return acc.withMutations(function(accMutable) {
      return currentReferences.getIn(['attrs', 'references'], Immutable.Map()).forEach(function(reference) {
        return accMutable.set(reference.get('_id'), reference);
      });
    });
  }, Immutable.Map());
  return {
    referencesOrder: refIds.toList(),
    references: references
  };
};

replaceReference = function(node, referencesOrder) {
  return _.extend({}, node, {
    content: _.map(node != null ? node.content : void 0, function(item) {
      var numbers, _ref4;
      if (item.type === 'reference' && ((_ref4 = item.attrs) != null ? _ref4.refIds : void 0)) {
        numbers = _.map(item.attrs.refIds, function(refId) {
          return referencesOrder.indexOf(refId) + 1;
        });
        return _.extend({}, item, {
          text: "(" + (numbers.sort(numberSort).join(',')) + ")",
          type: 'text',
          marks: [
            {
              type: 'superscript'
            }
          ]
        });
      } else if (!_.isEmpty(item.content)) {
        return replaceReference(item, referencesOrder);
      } else {
        return item;
      }
    })
  });
};

convertFromDraftJSToWordDoc = function(content) {
  var contentState, extensions, html, schema;
  extensions = processExtensions([sectionLinksExtension(), insertExtension()]);
  schema = getSchema(extensions.nodes, extensions.marks);
  html = renderEditorValue(content);
  contentState = prepareState(schema, [], html);
  return serializeNode(contentState.doc, {
    schema: schema
  }).then(function(_arg) {
    var result;
    result = _arg.result;
    return result;
  });
};

getMDGRecommendationParagraph = function(question, recommendation) {
  var conclusions, links, mdgRecommendation, mdgRecommendationContent, mdgRecommendationSelectedOption, recommendationFieldsOrder, recommendationParagraphStyle, recommendationTitle, sections, sectionsNames;
  recommendationParagraphStyle = getExportStyles().recommendationParagraphStyle;
  conclusions = recommendation.getIn(['templateData', 'conclusions']);
  sections = conclusions.get('sections');
  sectionsNames = conclusions.get('sectionsOrder').filter(function(sectionName) {
    return sectionName !== 'mdgRecommendation';
  });
  mdgRecommendation = sections.get('mdgRecommendation');
  mdgRecommendationSelectedOption = mdgRecommendation.get('options').find(function(option) {
    return option.get('value') === mdgRecommendation.get('selectedOption');
  });
  mdgRecommendationContent = mdgRecommendation.get('content');
  recommendationFieldsOrder = ['strengthOfEvidence', 'levelOfConfidence'];
  links = sections.getIn(['recommendation', 'links']);
  recommendationTitle = sections.getIn(['recommendation', 'recommendationTitle'], '');
  return convertFromDraftJSToWordDoc(mdgRecommendationContent).then(function(recommendationContentDocx) {
    var recommendationContentParagraphs, recommendationFieldsParagraphs, selectedOptionParagraph, titleParagraph;
    recommendationContentParagraphs = _.map(recommendationContentDocx.documentWrapper.document.body.root, function(para) {
      return new Paragraph(_.extend({
        children: para.root
      }, recommendationParagraphStyle));
    });
    recommendationContentDocx.documentWrapper.document.body.root = recommendationContentParagraphs;
    titleParagraph = simpleTitle(recommendationTitle || question.get('question'), question.get('_id'));
    selectedOptionParagraph = new Paragraph(_.extend({
      children: [
        new TextRun({
          text: (mdgRecommendationSelectedOption || Immutable.Map()).get('text'),
          bold: true
        })
      ]
    }, recommendationParagraphStyle));
    recommendationFieldsParagraphs = recommendationFieldsOrder.map(function(recommendationFieldId) {
      var fieldValue;
      fieldValue = sections.getIn(['recommendation', recommendationFieldId]);
      return new Paragraph(_.extend({
        children: [
          new TextRun({
            text: $.t("es:recommendations.metadataExtractionForm.fields." + recommendationFieldId),
            bold: true
          }), new TextRun({
            text: " "
          }), fieldValue && new TextRun({
            text: $.t("es:recommendations.metadataExtractionForm.values." + recommendationFieldId + "." + fieldValue)
          })
        ]
      }, recommendationParagraphStyle));
    });
    return mapImmutableToJsWithPromise(sectionsNames)(function(sectionName) {
      var section;
      section = sections.get(sectionName);
      if (_.isEmpty(section.get('content'))) {
        return;
      }
      return convertFromDraftJSToWordDoc(section.get('content')).then(function(sectionContentDocx) {
        var contentParagraphs;
        contentParagraphs = _.map(sectionContentDocx.documentWrapper.document.body.root, function(para) {
          return new Paragraph(_.extend({
            children: para.root
          }, recommendationParagraphStyle));
        });
        sectionContentDocx.documentWrapper.document.body.root = contentParagraphs;
        return [
          new Paragraph(_.extend({
            children: [
              new TextRun({
                text: section.get('description'),
                bold: true
              })
            ]
          }, recommendationParagraphStyle)), sectionContentDocx
        ];
      });
    }).then(function(sectionsParagraphs) {
      return [titleParagraph, selectedOptionParagraph, recommendationContentDocx].concat(__slice.call(recommendationFieldsParagraphs), __slice.call(sectionsParagraphs));
    });
  });
};

getRecommendationParagraph = function(question, recommendation) {
  var paragraphStyle, recommendationStrength, recommendationText, _recommendationDirection, _ref4;
  paragraphStyle = getExportStyles().paragraphStyle;
  recommendationText = recommendation.getIn(['templateData', 'conclusions', 'sections', 'recommendation', 'content']);
  _ref4 = getRecommendationDirectionAndStrength(recommendation.toJS()), _recommendationDirection = _ref4[0], recommendationStrength = _ref4[1];
  return convertFromDraftJSToWordDoc(recommendationText).then(function(recommendationContentDocx) {
    var certaintyOfEvidence, circles, label, _ref5;
    _ref5 = getCertaintyOfEvidenceCircles(question, recommendation), label = _ref5.label, circles = _ref5.circles;
    recommendationStrength = new Paragraph({
      children: [
        new TextRun({
          text: $.t("es:recommendations.metadataExtractionForm.fields.strengthOfRecommendation"),
          bold: true
        }), new TextRun({
          text: " "
        }), recommendationStrength && new TextRun({
          text: $.t("docsec:recommendation_strength." + recommendationStrength)
        })
      ],
      spacing: paragraphStyle.spacing
    });
    certaintyOfEvidence = new Paragraph({
      children: [
        new TextRun({
          text: $.t("es:recommendations.metadataExtractionForm.fields.certaintyOfEvidence"),
          bold: true
        }), new TextRun({
          text: " "
        }), new TextRun({
          text: circles.join('')
        }), new TextRun({
          text: " "
        }), new TextRun({
          text: label
        })
      ],
      spacing: paragraphStyle.spacing
    });
    return [recommendationContentDocx, recommendationStrength, certaintyOfEvidence];
  });
};

ITALICS_REGEXP = /(.*?)<i>(.*?)<\/i>(.*)/;

mapReferenceCitationPartsToTextRuns = function(currentText) {
  var afterText, beforeText, italicText, match, runStyle, _wholeText;
  runStyle = getExportStyles().runStyle;
  if (!currentText) {
    return [];
  }
  match = currentText.match(ITALICS_REGEXP);
  if (!match) {
    return [
      new TextRun({
        text: currentText,
        size: runStyle.size
      })
    ];
  }
  _wholeText = match[0], beforeText = match[1], italicText = match[2], afterText = match[3];
  return _.chain([[beforeText, false], [italicText, true]]).map(function(_arg) {
    var italics, text;
    text = _arg[0], italics = _arg[1];
    if (!text) {
      return null;
    }
    return new TextRun({
      text: text,
      size: runStyle.size,
      italics: italics
    });
  }).compact().union(mapReferenceCitationPartsToTextRuns(afterText)).value();
};

recommendationAndQuestionExists = function(questionId, recommendationId) {
  var questions;
  questions = alt.stores.QuestionsStore.getQuestions();
  return recommendationId && questionId && questions.get(questionId);
};

createWordExport = function() {
  var QuestionsStore, Store, allChapters, allComments, chapterPromises, extensions, paragraphStyle, schema, sectionsContent, titleStyle, wordExportStyles, _ref4, _ref5;
  _ref4 = alt.stores, Store = _ref4.DocumentSectionsV2Store, QuestionsStore = _ref4.QuestionsStore;
  _ref5 = getExportStyles(), wordExportStyles = _ref5.wordExportStyles, paragraphStyle = _ref5.paragraphStyle, titleStyle = _ref5.titleStyle;
  allChapters = createChaptersListWithNumericKeys(Immutable.List(), Store.getRootChaptersOrder());
  extensions = processExtensions([sectionLinksExtension(), insertExtension()]);
  schema = getSchema(extensions.nodes, extensions.marks);
  sectionsContent = {};
  chapterPromises = allChapters.map(function(chapter) {
    var sectionIds;
    chapter = chapter.set('headerTitle', chapter.get('chapterKeys').join('.') + ". " + chapter.get('title'));
    sectionIds = chapter.get('sections', Immutable.List());
    return fetchDocs(mediator.project.id, sectionIds.toJS()).then(function(sections) {
      var imagePromises, tableIds, tablePromise;
      imagePromises = _(_.compact(sections)).map(function(section) {
        var content;
        content = get(section, 'content', {});
        sectionsContent[section._id] = section;
        return gatherer('image', function(image) {
          return loadImage(image.attrs.src);
        })(content.doc);
      });
      tableIds = _.compact(_(sections).map(function(section) {
        return get(section, 'mdaTableId');
      }));
      tablePromise = fetchDocs(mediator.project.id, tableIds);
      return __slice.call(_.flatten(imagePromises)).concat([tablePromise]);
    }).then(W.all).then(function(_arg) {
      var images, tables, _i;
      images = 2 <= _arg.length ? __slice.call(_arg, 0, _i = _arg.length - 1) : (_i = 0, []), tables = _arg[_i++];
      _.each(tables, function(tableDoc) {
        return chapter = chapter.setIn(['tableData', tableDoc._id], Immutable.fromJS(tableDoc));
      });
      chapter = chapter.set('imageData', Immutable.fromJS(images));
      return chapter;
    });
  });
  allComments = [];
  return W.all(chapterPromises.toJS()).then(function(chapters) {
    var parsedChaptersPromise, references, referencesHolder, referencesOrder, _ref6;
    referencesHolder = [];
    chapters.forEach(function(chapter) {
      var sections;
      if (!chapter.get('refIds', Immutable.List()).isEmpty()) {
        referencesHolder = referencesHolder.concat([
          {
            type: 'reference',
            attrs: {
              refIds: chapter.get('refIds', Immutable.List()).toJS(),
              references: chapter.get('references', Immutable.Map()).toJS()
            }
          }
        ]);
      }
      sections = chapter.get('sections', Immutable.List());
      return sections.forEach(function(sectionId) {
        var section, _ref6;
        section = sectionsContent[sectionId];
        if (section) {
          return referencesHolder = referencesHolder.concat([
            {
              type: 'reference',
              attrs: {
                refIds: section.refIds || [],
                references: section.references || {}
              }
            }, gatherer('reference')((_ref6 = section.content) != null ? _ref6.doc : void 0)
          ]);
        }
      });
    });
    _ref6 = getReferencesSet(_.compact(_.flatten(referencesHolder))), referencesOrder = _ref6.referencesOrder, references = _ref6.references;
    parsedChaptersPromise = sequence(_.map(chapters, function(chapter) {
      return function() {
        var imageData, sectionDocsPromise;
        imageData = chapter.get('imageData', Immutable.Map()).toJS();
        sectionDocsPromise = reduceImmutableWithPromise(chapter.get('sections', Immutable.List()))(function(acc, sectionId) {
          var content, question, questionId, questions, recommendationDoc, recommendationId, recommendationParagraphPromise, sectionContent, state;
          sectionContent = sectionsContent[sectionId];
          if (!sectionContent) {
            return acc;
          }
          questionId = sectionContent.questionId, recommendationId = sectionContent.recommendationId;
          if (recommendationAndQuestionExists(questionId, recommendationId)) {
            questions = QuestionsStore.getQuestions();
            question = questions.get(questionId);
            recommendationDoc = Store.getState().getIn(['recommendations', recommendationId]);
            recommendationParagraphPromise = isMdgTablesSwitchOn() ? getMDGRecommendationParagraph(question, recommendationDoc) : getRecommendationParagraph(question, recommendationDoc);
            return recommendationParagraphPromise.then(function(recommendationParagraph) {
              return acc.set(sectionId, recommendationParagraph);
            });
          } else {
            content = sectionContent.mdaTableId ? chapter.getIn(['tableData', sectionContent.mdaTableId, 'content']).toJS() : get(sectionContent, 'content');
            if (!content) {
              return acc;
            }
            state = prepareState(schema, [], _.extend({}, content, {
              doc: replaceReference(content.doc, referencesOrder)
            }));
            return serializeNode(state.doc, {
              annotations: content.annotations,
              commentStartIdx: allComments.length,
              imageData: imageData,
              schema: schema
            }).then(function(_arg) {
              var comments, contentAsDocx;
              comments = _arg.comments, contentAsDocx = _arg.result;
              _.forEach(comments, function(comment) {
                return allComments.push(comment);
              });
              return acc.set(sectionId, contentAsDocx);
            });
          }
        }, Immutable.Map());
        return sectionDocsPromise.then(function(sectionDocs) {
          return chapter.set('sectionDocxs', sectionDocs);
        });
      };
    }));
    return parsedChaptersPromise.then(function(parsedChapters) {
      return {
        chapters: parsedChapters,
        referencesOrder: referencesOrder,
        references: references
      };
    });
  }).then(function(_arg) {
    var acoemLogoParagraph, chapterParagraphs, chapters, dateParagraph, references, referencesHeader, referencesOrder, referencesParagraphs, titleParagraph;
    chapters = _arg.chapters, referencesOrder = _arg.referencesOrder, references = _arg.references;
    acoemLogoParagraph = new Paragraph({
      children: [
        new ImageRun({
          data: acoemLogoBase64,
          transformation: {
            width: 276,
            height: 76
          }
        })
      ],
      spacing: {
        line: 1240,
        before: 240,
        after: 240
      }
    });
    titleParagraph = new Paragraph({
      children: [
        new TextRun(_.extend({
          text: mediator.project.get('name')
        }, _.omit(titleStyle, 'spacing')))
      ],
      spacing: titleStyle.spacing
    });
    dateParagraph = new Paragraph({
      children: [
        new TextRun({
          text: $.t('mdg_tables:effective_date', {
            date: moment(new Date()).format("MMMM DD, YYYY")
          })
        })
      ]
    });
    chapterParagraphs = _.reduce(chapters, function(acc, chapter) {
      acc.push(chapterTitle(chapter, referencesOrder));
      chapter.get('sections').forEach(function(sectionId) {
        var questionId, recommendationId, section, sectionDocx;
        section = sectionsContent[sectionId];
        if (!section) {
          return;
        }
        questionId = section.questionId, recommendationId = section.recommendationId;
        sectionDocx = chapter.getIn(['sectionDocxs', sectionId]);
        if (recommendationAndQuestionExists(questionId, recommendationId)) {
          return acc.push(_.flatten(_.compact(sectionDocx)));
        } else {
          return acc.push(paragraphWithEditorContent(section, sectionDocx, referencesOrder));
        }
      });
      return acc;
    }, []);
    referencesHeader = new Paragraph({
      text: $.t('nav.references'),
      heading: HeadingLevel.HEADING_2
    });
    referencesParagraphs = referencesOrder.map(function(refId, idx) {
      var text;
      text = isEvolent() ? amaFormat(references.get(refId).toJS(), true) : vancouverFormat(references.get(refId).toJS(), true);
      return new Paragraph({
        children: mapReferenceCitationPartsToTextRuns("" + (idx + 1) + ". " + text),
        spacing: paragraphStyle.spacing
      });
    });
    return [isMdgTablesSwitchOn() ? acoemLogoParagraph : void 0, isMdgTablesSwitchOn() || isHealthAdvisor() ? dateParagraph : null, titleParagraph].concat(__slice.call(chapterParagraphs), [referencesParagraphs.isEmpty() ? null : referencesHeader], __slice.call(referencesParagraphs.toJS()));
  }).then(function(paragraphs) {
    var doc, flattenParagraphs, newNumbering, paragraphsAsArray, parsedParagraphs;
    flattenParagraphs = _.flatten(_.compact(paragraphs));
    newNumbering = _.reduce(flattenParagraphs, function(num, p) {
      if (isDocx(p)) {
        p.numbering.abstractNumberingMap.forEach(function(value, key) {
          return num.numbering.abstractNumberingMap.set(key, value);
        });
      }
      return num;
    }, {
      numbering: {
        abstractNumberingMap: new Map()
      }
    });
    parsedParagraphs = _.map(flattenParagraphs, function(p) {
      var _ref6, _ref7, _ref8;
      if (isDocx(p)) {
        return __slice.call((_ref6 = p.documentWrapper) != null ? (_ref7 = _ref6.document) != null ? (_ref8 = _ref7.body) != null ? _ref8.root : void 0 : void 0 : void 0);
      } else {
        return p;
      }
    });
    paragraphsAsArray = __slice.call(_.flatten(parsedParagraphs));
    doc = new Document({
      comments: {
        children: allComments
      },
      styles: wordExportStyles,
      sections: [
        {
          properties: {
            type: SectionType.CONTINUOUS,
            page: {
              pageNumbers: {
                start: 1,
                formatType: NumberFormat.DECIMAL
              }
            }
          },
          children: __slice.call(paragraphsAsArray),
          footers: {
            "default": footerParagraph()
          }
        }
      ]
    });
    doc.numbering.abstractNumberingMap = newNumbering.numbering.abstractNumberingMap;
    return doc;
  });
};

base64ToBlob = function(base64Data, contentType) {
  var begin, byteArrays, byteCharacters, bytes, bytesLength, end, offset, sliceIndex, sliceSize, slicesCount, _i, _j;
  if (contentType == null) {
    contentType = '';
  }
  sliceSize = 1024;
  byteCharacters = atob(base64Data);
  bytesLength = byteCharacters.length;
  slicesCount = Math.ceil(bytesLength / sliceSize);
  byteArrays = new Array(slicesCount);
  for (sliceIndex = _i = 0; 0 <= slicesCount ? _i < slicesCount : _i > slicesCount; sliceIndex = 0 <= slicesCount ? ++_i : --_i) {
    begin = sliceIndex * sliceSize;
    end = Math.min(begin + sliceSize, bytesLength);
    bytes = new Array(end - begin);
    for (offset = _j = begin; begin <= end ? _j < end : _j > end; offset = begin <= end ? ++_j : --_j) {
      bytes[offset - begin] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, {
    type: contentType
  });
};

module.exports = {
  exportToWord: function() {
    return createWordExport().then(function(doc) {
      return Packer.toBlob(doc).then(function(blob) {
        return FileSaver.saveFile(blob, "" + (mediator.project.get('name').slice(0, 255)) + ".docx");
      });
    })["catch"](errorHandler);
  },
  recordRevision: function() {
    return createWordExport().then(function(doc) {
      return Packer.toBlob(doc).then(function(blob) {
        var revisionFilename;
        revisionFilename = mediator.services.clock.getTimestamp().toString();
        return mediator.project.getDocFor('document_revisions').then(function(revisionsDoc) {
          revisionsDoc.set('latestRevision', revisionFilename);
          revisionsDoc.save();
          return mediator.services.persistenceAdapter.attach(revisionsDoc, revisionFilename, blob);
        });
      });
    }).then(function() {
      return mediator.dialogs.info($.t('docsec:management.revision_recorded'));
    })["catch"](errorHandler);
  },
  exportDiff: function() {
    return mediator.project.getDocFor('document_revisions').then(function(revisionsDoc) {
      if (!revisionsDoc.get('latestRevision')) {
        mediator.dialogs.info($.t('docsec:management.no_revisions'));
        return;
      }
      return createWordExport().then(function(newDoc) {
        return Packer.toBlob(newDoc);
      }).then(function(blob) {
        var url;
        url = "" + (DbHelper.getBackendUrl()) + "/revisions/" + mediator.project.id + "/diff/latest";
        return fetch(url, {
          method: 'POST',
          credentials: 'include',
          body: blob,
          headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          }
        });
      }).then(function(response) {
        if (response.ok) {
          return response.blob();
        }
        throw new Error('Error while exporting diff');
      }).then(function(blob) {
        return FileSaver.saveFile(blob, "" + (mediator.project.get('name').slice(0, 255)) + ".docx");
      });
    })["catch"](errorHandler);
  }
};
